import _extends from "@babel/runtime/helpers/extends";
import { createVNode as _createVNode } from "vue";
import { defineComponent } from 'vue';
import Form, { form } from './Form';
import './dist.css'; // @ts-ignore

import bg from './bg.jpg'; // @ts-ignore

import logo from './logo.png';

var login = _extends({
  bgURL: {
    type: String,
    default: bg
  },
  logoURL: {
    type: String,
    default: logo
  }
}, form);

export default defineComponent({
  name: 'uiv-login',
  props: login,

  setup(props, _ref) {
    var {
      slots
    } = _ref;
    return () => {
      var {
        title,
        password,
        username,
        onSubmit,
        onReset,
        bgURL,
        logoURL
      } = props;
      return _createVNode("div", {
        "class": "uiv-login-wrapper",
        "style": {}
      }, [_createVNode("div", {
        "style": {
          backgroundImage: "url(" + bgURL + ")"
        }
      }, null), _createVNode("div", null, [_createVNode("div", {
        "class": "uiv-login-logo"
      }, [_createVNode("img", {
        "src": logoURL
      }, null)]), slots.default ? slots.default() : _createVNode(Form, {
        title,
        password,
        username,
        onSubmit,
        onReset
      }, null)])]);
    };
  }

});
//# sourceMappingURL=index.js.map